import { render, staticRenderFns } from "./event_publish_page.vue?vue&type=template&id=02b1605a&scoped=true&"
import script from "./event_publish_page.vue?vue&type=script&lang=js&"
export * from "./event_publish_page.vue?vue&type=script&lang=js&"
import style0 from "./event_publish_page.vue?vue&type=style&index=0&id=02b1605a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b1605a",
  null
  
)

export default component.exports